import { SET_OPEN_DOWNLOAD } from 'store/types/report';

export const setOpenDownload = (download) => {
  return {
    type: SET_OPEN_DOWNLOAD,
    payload: download,
  };
};
